import { inject, Injectable } from '@angular/core';
import { BaseApi } from './_base-api';
import { ENVIRONMENT } from '@controladad/ng-base';
import { map } from 'rxjs';

export type FileType = 'Product' | 'Variant' | 'App';
export type UploadResult = { imagePath: string; imageUrl: string };

@Injectable({
  providedIn: 'root',
})
export class AttachmentApiService extends BaseApi<any> {
  private readonly environment = inject(ENVIRONMENT); //TODO: Should remove after added to BaseApi
  constructor() {
    super('');
  }

  upload(file: File, type: FileType = 'Product') {
    const form = new FormData();
    form.set('Image', file);
    form.set('Type', type);

    return http$
      .post<{ paths: UploadResult }>(`${this.environment.filesApiUrl}`, form)
      .pipe(map((i) => i.paths));
  }
}
